/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import type { LinkRenderProps } from 'react-aria-components';
import { type ContextValue, DEFAULT_SLOT, Link as LinkCore, LinkContext as LinkCoreContext, type LinkProps as LinkCoreProps, Provider, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { IconContext } from '../icon/icon.component';

interface LinkProps extends Omit<LinkCoreProps, 'style' | 'className'> {
  /** The size variant of the link. (Default: 14) */
  size?: keyof typeof sizeVariants,
  /** The weight variant of the text. (Default: regular) */
  weight?: keyof typeof weightVariants,
  style?: stylex.StyleXStyles;
  UNSAFE_IconContext?: Parameters<typeof IconContext.Provider>[0]['value'] | ((renderProps: LinkRenderProps) => Parameters<typeof IconContext.Provider>[0]['value']);
}

const LinkContext = createContext<ContextValue<LinkProps, HTMLAnchorElement>>({});

const Link = forwardRef((props: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
  [props, ref] = useContextProps(props, ref, LinkContext);

  const { size = 14, style, weight = 'regular', children, UNSAFE_IconContext, ...coreProps } = props;

  return (
    <LinkCore
      ref={ref}
      {...stylex.props(
        styles.base,
        sizeVariants[size],
        weightVariants[weight],
        letterSpacingVariants[`${weight}${size.toString()}` as keyof typeof letterSpacingVariants],
        style
      )}
      {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [IconContext, {
            slots: {
              [DEFAULT_SLOT]: {},
              [LINK_SLOTS.LEFT_ACCESSORY]: {
                size: 16,
                ...(typeof UNSAFE_IconContext === 'function' ? UNSAFE_IconContext(renderProps) : UNSAFE_IconContext),
              },
              [LINK_SLOTS.RIGHT_ACCESSORY]: {
                size: 12,
                ...(typeof UNSAFE_IconContext === 'function' ? UNSAFE_IconContext(renderProps) : UNSAFE_IconContext),
              },
            },
          }]]}>
          {typeof children === 'function' ? children(renderProps) : children}
        </Provider>
      )}
    </LinkCore>
  );
});

const styles = stylex.create({
  base: {
    alignItems: 'center',
    color: $.textInteractive,
    display: 'inline-flex',
    fontFamily: 'BasierCircle',
    fontFeatureSettings: 'liga off, clig off',
    fontWeight: 400,
    gap: 4,
    textDecoration: 'none',
  },
});

const sizeVariants = stylex.create({
  20: { fontSize: 20 },
  18: { fontSize: 18 },
  16: { fontSize: 16 },
  14: { fontSize: 14 },
  13: { fontSize: 13 },
  12: { fontSize: 12 },
  11: { fontSize: 11 },
  10: { fontSize: 10 },
  8: { fontSize: 8 },
});

const weightVariants = stylex.create({
  semibold: { fontWeight: 600 },
  medium: { fontWeight: 500 },
  regular: { fontWeight: 400 },
});

const letterSpacingVariants = stylex.create({
  semibold20: { letterSpacing: -0.04 },
  medium20: { letterSpacing: -0.24 },
  regular20: { letterSpacing: -0.4 },
  semibold18: { letterSpacing: -0.09 },
  medium18: { letterSpacing: -0.216 },
  regular18: { letterSpacing: -0.396 },
  semibold16: { letterSpacing: 0 },
  medium16: { letterSpacing: -0.1 },
  regular16: { letterSpacing: -0.32 },
  semibold14: { letterSpacing: 0.14 },
  medium14: { letterSpacing: -0.112 },
  regular14: { letterSpacing: -0.252 },
  semibold13: { letterSpacing: 0.1 },
  medium13: { letterSpacing: -0.065 },
  regular13: { letterSpacing: -0.26 },
  semibold12: { letterSpacing: 0.12 },
  medium12: { letterSpacing: 0.12 },
  regular12: { letterSpacing: -0.12 },
  semibold11: { letterSpacing: -0.055 },
  medium11: { letterSpacing: -0.055 },
  regular11: { letterSpacing: -0.055 },
  semibold10: { letterSpacing: -0.05 },
  medium10: { letterSpacing: -0.05 },
  regular10: { letterSpacing: -0.05 },
  semibold8: { letterSpacing: 0 },
  medium8: { letterSpacing: 0 },
  regular8: { letterSpacing: 0 },
});

const LINK_SLOTS = {
  RIGHT_ACCESSORY: 'right-accessory',
  LEFT_ACCESSORY: 'left-accessory',
};

export { LINK_SLOTS, Link, LinkContext, LinkCore, LinkCoreContext, type LinkProps };

